<template>
  <div class="app-container">
    <nav class="add-navigation flex-wrap">
      <div
        @click="$router.push({ name: 'system-admin-resellers' })"
        class="back-link  mr-2"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p class="white_space">Back to Resellers</p>
      </div>
      <div class="buttons-wrapper flex-wrap">
        <div
          @click="$router.push({ name: 'system-admin-resellers' })"
          class="secondary-button my-2 my-md-0"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button my-2 my-md-0">
          <primary-button @click.native="addReseller"
            >Submit</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="white_space container-title d-block mb-4 px-3">Add Reseller Information</span>
        <div class="row px-3">
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="first name"
                    class="field row-first"
                    :value="reseller.first_name"
                    @input="handleFirstName"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('first name') }"
                    placeholder="Enter first name"
            />
            <div class="help is-danger" v-if="errors.has('first name')">
              {{ errors.first("first name") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="last name"
                    class="row-first"
                    :value="reseller.last_name"
                    @input="handleLastName"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('last name') }"
                    placeholder="Enter last name"
            />
            <div class="help is-danger" v-if="errors.has('last name')">
              {{ errors.first("last name") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="number"
                    name="phone"
                    class="field row-second"
                    v-model="reseller.contact.phone"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('phone') }"
                    placeholder="Enter phone"
            />
            <div class="help is-danger" v-if="errors.has('phone')">
              {{ errors.first("phone") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="email"
                    class="row-second"
                    v-model="reseller.contact.email"
                    v-validate="{required: true, email: true}"
                    :class="{ input: true, 'is-danger': errors.has('email') }"
                    placeholder="Enter email"
            />
            <div class="help is-danger" v-if="errors.has('email')">
              {{ errors.first("email") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="password"
                    name="password"
                    class="row-first"
                    v-model="reseller.contact.passwd"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('password') }"
                    placeholder="Enter password"
            />
            <div v-if="errors.has('password')" class="help is-danger">
              {{ errors.first("password") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-select
                    type="text"
                    name="country"
                    class="row-second"
                    v-validate="'required'"
                    v-model="reseller.contact.country_uuid"
                    :class="{ input: true, 'is-danger': errors.has('country') }"
                    placeholder="Select Country"
            >
              <option
                      :value="i.country_uuid"
                      v-for="(i, k) in countrys"
                      :key="k"
              >
                {{ i.nice_name ? i.nice_name : i.name }}
              </option>
            </primary-select>
            <div class="help is-danger" v-if="errors.has('country')">
              {{ errors.first("country") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="address"
                    class="field row-address row-first"
                    v-model="reseller.contact.address"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('address') }"
                    placeholder="Enter address"
            />
            <div class="help is-danger" v-if="errors.has('address')">
              {{ errors.first("address") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="zipcode"
                    class="row-first"
                    v-model="reseller.contact.zipcode"
                    v-validate="{required: true, numeric: true}"
                    :class="{ input: true, 'is-danger': errors.has('zipcode') }"
                    placeholder="Enter zip code"
            />
            <div class="help is-danger" v-if="errors.has('zipcode')">
              {{ errors.first("zipcode") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="state"
                    class="field row-first"
                    v-model="reseller.contact.state"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('state') }"
                    placeholder="State"
            />
            <div class="help is-danger" v-if="errors.has('state')">
              {{ errors.first("state") }}
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <primary-input
                    type="text"
                    name="city"
                    class="field row-first"
                    v-model="reseller.contact.city"
                    v-validate="'required'"
                    :class="{ input: true, 'is-danger': errors.has('city') }"
                    placeholder="Enter city"
            />
            <div class="help is-danger" v-if="errors.has('city')">
              {{ errors.first("city") }}
            </div>
          </div>
          <!-- <div class="list primary-input-container multiselect row-second">
              <p class="pimary-input-title">Company</p>
              <multiselect
                v-model="reseller.companies"
                :options="allcompanies"
                :value="allcompanies"
                :multiple="true"
                :selectLabel="''"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Pick Company"
                label="name"
                track-by="company_uuid"
                :preselect-first="true"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen, option }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selected</span>
                </template>
              </multiselect>
            </div>
            <div class="help is-danger" v-if="errors.has('company')">{{ errors.first('company') }}</div>-->
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    contactError: null,
    role: ["Admin", "Normal"],
    reseller: {
      first_name: null,
      last_name: null,
      reseller_name: null,
      companies: [],
      contact: {
        first_name: null,
        last_name: null,
        address: null,
        phone: null,
        logo_file_uuid: null,
        state: null,
        email: null,
        city: null,
        zipcode: null,
        country_uuid: null,
      },
    },
    file: null,
    countrys: [],
    allcompanies: [],
  }),
  created() {
    this.getCompanyList();
    this.getCountryList();
  },
  methods: {
    handleFirstName(v) {
      this.reseller.first_name = this.$capitalize(v);
    },
    handleLastName(v) {
      this.reseller.last_name = this.$capitalize(v);
    },
    async getCompanyList() {
      const { total } = await this.$store.dispatch("GetCompanyList", {});

      const res = await this.$store.dispatch("GetCompanyList", {
        perPage: total,
      });
      this.allcompanies = res.items.map((item) => {
        return { name: item.company_name, company_uuid: item.company_uuid };
      });
    },
    getCountryList() {
      this.$store.dispatch("getCountryList", {}).then((res) => {
        this.countrys = res.items;
      });
    },
    addReseller: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        this.reseller.contact.first_name = this.reseller.first_name;
        this.reseller.contact.last_name = this.reseller.last_name;
        this.reseller.reseller_name =
          this.reseller.first_name + this.reseller.last_name;

        this.reseller.companies = this.reseller.companies.map((i) => {
          return { company_uuid: i.company_uuid };
        });

        const res = await this.$store.dispatch("AddReseller", this.reseller);

        this.$snotify.success("Reseller have been added.", {
          timeout: 6000,
        });

        this.$router.push({ name: "system-admin-resellers" });
      } catch (err) {
        if (err.errors) {
          this.contactError = err.errors[0].contact
            ? err.errors[0].contact
            : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else if (err.response) {
          this.$snotify.error(
            err.response.data.errors
              ? err.response.data.errors
              : err.response.data.error.message,
            { timeout: 6000 }
          );
        } else {
          this.$snotify.error(err, { timeout: 6000 });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  position: absolute;
  top: 60px;
  margin: 0 !important;
}
.row .help:last-child {
  margin-left: 15px;
}
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: auto;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
    }
    .row {
      .input {
        margin-bottom: 20px;
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
@media (max-width: 339px) {
  .secondary-button{
    min-width: 110px ;
  }
}
</style>

